<template>
  <div>
    <div v-if="showLabel" class="text-subtitle-1 font-weight-bold mb-2">{{ label }}</div>
    <div class="d-flex flex-wrap ga-1">
      <v-btn
        size="small"
        :variant="modelValue === 'all' ? 'flat' : 'outlined'"
        :color="modelValue === 'all' ? 'primary' : undefined"
        @click="$emit('update:modelValue', 'all')"
      >All</v-btn>
      <v-btn
        v-for="st in visibleServiceTypes"
        :key="st.id"
        size="small"
        :variant="modelValue === st.id.toString() ? 'flat' : 'outlined'"
        :color="modelValue === st.id.toString() ? 'primary' : undefined"
        @click="$emit('update:modelValue', st.id.toString())"
      >{{ st.label_on_search_button || st.name }}</v-btn>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { log } from "@/composables/useLog";
import { getServiceTypes } from "@/composables/useServiceTypesAPI";
import store from "@/store";

export default defineComponent({
  name: 'ServiceTypeButtonFilter',
  props: {
    modelValue: {
      type: String,
      default: 'all'
    },
    label: {
      type: String,
      default: 'Service Type'
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      serviceTypes: []
    }
  },
  computed: {
    isAdmin() {
      const user = store.getters.getUser;
      return user?.is_admin || user?.admin || false;
    },
    visibleServiceTypes() {
      if (this.isAdmin) {
        return this.serviceTypes;
      }
      return this.serviceTypes.filter(st => st.show_in_search);
    }
  },
  methods: {
    async loadServiceTypes() {
      try {
        const token = store.getters.getToken;
        const response = await getServiceTypes(token);
        if (!response.error) {
          this.serviceTypes = response.service_types || [];
          log("ServiceTypeButtonFilter loaded service types:");
          log(this.serviceTypes);
        }
      } catch (err) {
        log("Error loading service types in ServiceTypeButtonFilter:");
        log(err);
      }
    }
  },
  mounted() {
    this.loadServiceTypes();
  }
});
</script>
